<template>
  <LoginForm />
  <div class="register-link">
    <p>Don't have an account? <router-link to="/register">Register here</router-link></p>
  </div>
</template>

<script>
import LoginForm from '@/components/auth/LoginForm.vue';

export default {
  name: "LoginPage",
  components: {
    LoginForm,
  },
};
</script>

<style scoped>
/* Add any necessary styling here */
</style>